export type AppRole = "admin" | "data_operator" | "viewer";

export const ROLE_LABELS: Record<AppRole, string> = {
  admin: "Admin",
  data_operator: "Data Operator",
  viewer: "Viewer",
};

const ROLE_LEVEL: Record<AppRole, number> = {
  viewer: 0,
  data_operator: 1,
  admin: 2,
};

export function isAppRole(value: unknown): value is AppRole {
  return value === "admin" || value === "data_operator" || value === "viewer";
}

export function roleMeets(actual: AppRole, required: AppRole): boolean {
  return ROLE_LEVEL[actual] >= ROLE_LEVEL[required];
}

export function canImportData(role: AppRole): boolean {
  return roleMeets(role, "data_operator");
}

export function canUseAi(role: AppRole): boolean {
  return role === "admin";
}

export function canReviewData(role: AppRole): boolean {
  return role === "admin";
}
